import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteRequest } from 'src/lib/api-client'
import { useToast } from 'src/shared/hooks/use-toast'

export const useDeleteInvite = () => {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: async (inviteId: number) => {
      const response = await deleteRequest(`/users/invites?invite_id=${inviteId}`)
      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['invites'] })
      toast({
        title: 'Invite deleted',
        description: 'The invite has been successfully deleted.',
      })
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Failed to delete invite',
        description: 'Please try again later.',
      })
    },
  })
}
